import type { BusinessFlow, BusinessFlowLane, BusinessFlowStep, ConceptEntity } from '@/types/knowledge_graph'
import { cn } from '@/lib/utils'
import { BusinessFlowStepsView } from './BusinessFlowStepsView'
import { BusinessFlowLanesView } from './BusinessFlowLanesView'

interface Props {
  flows: BusinessFlow[]
  lanes: BusinessFlowLane[] | null
  entities?: ConceptEntity[]
  viewMode: 'steps' | 'lanes'
  onViewModeChange: (mode: 'steps' | 'lanes') => void
  onUpdateStep: (businessFlowId: string, stepId: string, changes: Partial<BusinessFlowStep>) => void
}

const FILTER_BTN_CLASS = 'py-1 px-3.25 text-[11px] font-semibold rounded-full border-[1.5px] border-(--bp-border) bg-(--bp-surface) text-(--bp-ink3) cursor-pointer'
const FILTER_BTN_ACTIVE_CLASS = 'bg-(--bp-ink) text-white border-(--bp-ink)'

export function FlowsTab ({ flows, lanes, entities = [], viewMode, onViewModeChange, onUpdateStep }: Props): React.ReactElement {
  return (
    <>
      <div className='flex gap-1.5 flex-wrap mb-4'>
        <button
          className={cn(FILTER_BTN_CLASS, viewMode === 'steps' && FILTER_BTN_ACTIVE_CLASS)}
          onClick={() => onViewModeChange('steps')}
        >
          ステップリスト
        </button>
        <button
          className={cn(FILTER_BTN_CLASS, viewMode === 'lanes' && FILTER_BTN_ACTIVE_CLASS)}
          onClick={() => onViewModeChange('lanes')}
        >
          フロー表示
        </button>
      </div>
      {viewMode === 'lanes'
        ? <BusinessFlowLanesView lanes={lanes ?? []} />
        : <BusinessFlowStepsView flows={flows} entities={entities} onUpdateStep={onUpdateStep} />}
    </>
  )
}
